module.exports = __webpack_public_path__ + "img/forum-2015.e18aa7e6.jpg";